import { BASE_URL } from "../data/constants";
import { getToken } from "./authStore";

export type VenueNowPlayingTrack = {
  // Metadata från AudD:s top-level-fält. Omslaget härleds serverside ur
  // songLink, så det skickas inte med.
  title?: string;
  artist?: string;
  album?: string | null;
  songLink?: string | null;
  year?: string | null;

  // Fristående och frivillig.
  previewUrl?: string | null;
  confidence?: number | null;
};

export type VenueNowPlayingInput = {
  venueId: string;
  track: VenueNowPlayingTrack;

  // 👇 behövs för server-side gate (förutom superadmin-bypass)
  selectionToken?: string;
  lat?: number;
  lon?: number;
};

export async function updateVenueNowPlaying(input: VenueNowPlayingInput) {
  const token = getToken();

  const r = await fetch(`${BASE_URL}/recognize/updateVenueNowPlaying`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(input),
  });

  const data = await r.json().catch(() => null);

  if (!r.ok) {
    return { ok: false as const, error: data?.error ?? "post_failed", data };
  }

  return { ok: true as const, data };
}
